const getCheckout = state => state.checkout || {};
const getCheckoutData = state => getCheckout(state).data || {};
const getSelectedStore = state => getCheckoutData(state).selectedStore || false;
const getDeliveryTime = state => getCheckout(state).deliveryTime.values;
const getShippingBlocked = state => getCheckoutData(state).shippingBlocked;

const getDeliveryMode = state => getCheckoutData(state).deliveryMode || null;
const getPreviousDeliveryMode = state => getCheckoutData(state).previousDeliveryMode || null;

const getAddressForBilling = state => getCheckoutData(state).addressForBilling || null;
const showShippingCountdown = state => getCheckout(state).showShippingCountdown;

const isPickupExpressEnterPhoneEnabled = state => getCheckout(state).pickupExpressEnterPhoneEnabled;
const getUseDeliveryAsBilling = state => getCheckoutData(state).useDeliveryAsBilling;
export default {
    getSelectedStore,
    getDeliveryTime,
    getShippingBlocked,
    getCheckoutData,
    getDeliveryMode,
    getAddressForBilling,
    getPreviousDeliveryMode,
    showShippingCountdown,
    isPickupExpressEnterPhoneEnabled,
    getUseDeliveryAsBilling,
};
